import React, { useState } from 'react';
import HeroSection from '../components/landing/HeroSection';
import VideoSection from '../components/landing/VideoSection';
import ProblemSolutionSection from '../components/landing/ProblemSolutionSection';
import ServicesSection from '../components/landing/ServicesSection';
import ProofSection from '../components/landing/ProofSection';
import OfferSection from '../components/landing/OfferSection';
import FAQSection from '../components/landing/FAQSection';
import ContactSection from '../components/landing/ContactSection';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header />
      <main>
        <HeroSection />
        <VideoSection />
        <ProblemSolutionSection />
        <ServicesSection />
        <ProofSection />
        <OfferSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
